import { useQuery } from "@tanstack/react-query"
import { API_URL, QUERY_KEYS } from "../constants"
import { Organization } from "../types/Organization"

export const useGetOrganization = (orgId: string, token: string) =>
  useQuery<Organization, Error>({
    queryKey: QUERY_KEYS.organization(orgId),
    queryFn: async () => {
      const res = await fetch(`${API_URL}/private/organizations/${orgId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      if (!res.ok) {
        const parsed = await res.json()
        throw new Error(parsed.error ?? parsed.message ?? parsed ?? "Internal Server Error")
      }
      const json = await res.json()
      if (json.error) {
        throw new Error(json.error)
      }
      return json
    },
  })
